import forge from 'node-forge';

export interface GeneratedSshKeyPair {
  privateKeyPem: string;
  publicKeyOpenSsh: string;
  keyName: string;
}

function slugifySegment(value: string) {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 32);
}

function buildKeyName(seed?: string) {
  const slug = slugifySegment(seed || 'mapleos');
  return `id_rsa_${slug || 'mapleos'}`;
}

export async function generateSshKeyPair(options?: { comment?: string; nameHint?: string }) {
  const comment = (options?.comment || 'mapleos-generated').trim();
  const keyName = buildKeyName(options?.nameHint || comment);

  const keyPair = await new Promise<forge.pki.rsa.KeyPair>((resolve, reject) => {
    forge.pki.rsa.generateKeyPair({ bits: 3072, workers: -1 }, (error, pair) => {
      if (error || !pair) {
        reject(error || new Error('SSH keypair generation failed.'));
        return;
      }

      resolve(pair);
    });
  });

  return {
    privateKeyPem: forge.pki.privateKeyToPem(keyPair.privateKey).trim(),
    publicKeyOpenSsh: forge.ssh.publicKeyToOpenSSH(keyPair.publicKey, comment).trim(),
    keyName,
  } satisfies GeneratedSshKeyPair;
}
